import { useInfiniteQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import { PostAlertsRequest } from '@toggle/toggle';

import { postAlerts } from '~/services/event-alerts/event-alerts-service';

import { QUERY_KEY_EVENT_ALERTS } from './event-alerts-query-keys';

export const usePostAlerts = (body: PostAlertsRequest) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_EVENT_ALERTS, body],
    queryFn: ({ pageParam }) =>
      postAlerts({ ...body, next: pageParam ?? undefined }),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage): string | null =>
      lastPage?.next_cursor ?? null,
    staleTime: getTimeTillEndOfDayMs(),
  });
